__turbopack_context__.v({
  "button": "StripeNativePaymentButton-module__tLu5dq__button",
  "container": "StripeNativePaymentButton-module__tLu5dq__container",
  "dummy": "StripeNativePaymentButton-module__tLu5dq__dummy",
  "errorMessage": "StripeNativePaymentButton-module__tLu5dq__errorMessage",
  "loadingButtonWrapper": "StripeNativePaymentButton-module__tLu5dq__loadingButtonWrapper",
  "readyButtonContent": "StripeNativePaymentButton-module__tLu5dq__readyButtonContent",
  "wrapper": "StripeNativePaymentButton-module__tLu5dq__wrapper",
});
